import React, { Fragment } from 'react';
import classNames from 'classnames';

import css from './MultiColumnFeature.module.scss';

const MultiColumnFeature = ({ heading, description, data, customClass }) => {
	return (
		<div className={classNames(css.feature, css[customClass])}>
			<h2 data-aos="fade-up" data-aos-offset="-1000">
				{heading}
			</h2>
			{description && (
				<p
					className={css.description}
					data-aos="fade-up"
					data-aos-offset="-1000"
				>
					{description}
				</p>
			)}
			<div className={css.contentWrapper}>
				{data.map(({ id, src, alt, heading, description }) => (
					<div
						data-aos="fade-up"
						data-aos-offset="-1000"
						key={id}
						className={css.singleFeature}
					>
						<img
							src={`/images/components/multi-column-feature/${src}`}
							alt={alt}
						/>
						<div className={css.content}>
							<h4>{heading}</h4>
							<p>
								{Array.isArray(description)
									? description.map((item, index) => (
											<Fragment key={index}>{item}</Fragment>
									  ))
									: description}
							</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default MultiColumnFeature;
